module.exports = __webpack_public_path__ + "static/img/banner.c585e9a3.jpg";